module.exports = __webpack_public_path__ + "static/media/telehealth-bcba.a5103cb6.jpg";